<div class="video-upload-wrap">
	<img [src]="videoThumbnail" style="max-width: 100%" />
	<input class="file-upload-input" name="file" type="file" accept="video/mp4,video/x-m4v" size="1000000" (change)="onVideoChanged($event)" #createEventFileInput />

	<div class="drag-text" *ngIf="!videoUpload" [class.--overlay]="!!videoThumbnail">
		<p style="line-height: 1">
			<!--			<mat-icon class="upload-icon">cloud_upload</mat-icon>-->
			<img class="upload-icon" src="assets/images/video.png" />
			Drag and drop a file or click to choose an video.
		</p>
	</div>

	<mat-icon class="file-edit-icon" *ngIf="videoUpload" (click)="createEventFileInput.click()">edit</mat-icon>
	<ng-template #defaultUpdateVideoPicker>
		<button [disableRipple]="true" class="file-upload-btn" (click)="createEventFileInput.click()" value="Choose Video"></button>
	</ng-template>
</div>

<ng-template #fileUploadExceedDialog>
	<mat-toolbar>
		<button [disableRipple]="true" matDialogClose class="close" mat-icon-button>
			<mat-icon>cancel</mat-icon>
		</button>
	</mat-toolbar>
	<mat-dialog-content style="max-width: 340px; min-width: 250px; width: auto; height: auto; padding: 0px">
		<div class="video-section" color="primary">
			<div class="action-content">
				<div class="action-video">
					<img src="assets/images/file-size-limit-exceeded.png" />
				</div>
				<div class="action-title">
					<h2>File size limit exceeded.</h2>
				</div>
				<div class="action-message">
					<h5>Maximum allowed size is 10MB.</h5>
				</div>
			</div>
		</div>
	</mat-dialog-content>
</ng-template>
